import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useResetPasswordMutation } from "../../Services/LoginAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email || "";
    const otp = location.state?.otp || "";

    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({ password: "", passwordConfirmation: "", apiError: "" });

    const [loginUser, { isLoading }] = useResetPasswordMutation();
    const [APIerror, setApiError] = useState("");

    // Validation function
    const validateFields = (field, value) => {
        let newErrors = { ...errors };

        if (field === "password") {
            if (!value.trim()) {
                newErrors.password = "Password is required.";
            } else if (value.length < 6) {
                newErrors.password = "Password must be at least 6 characters.";
            } else {
                newErrors.password = "";
            }
        }

        if (field === "passwordConfirmation") {
            if (!value.trim()) {
                newErrors.passwordConfirmation = "Confirm password is required.";
            } else if (value !== password) {
                newErrors.passwordConfirmation = "Passwords do not match.";
            } else {
                newErrors.passwordConfirmation = "";
            }
        }

        setErrors(newErrors);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Validate before submission
        let newErrors = {};
        if (!password.trim()) {
            newErrors.password = "Password is required.";
        } else if (password.length < 6) {
            newErrors.password = "Password must be at least 6 characters.";
        }
    
        if (!passwordConfirmation.trim()) {
            newErrors.passwordConfirmation = "Confirm password is required.";
        } else if (passwordConfirmation !== password) {
            newErrors.passwordConfirmation = "Passwords do not match.";
        }
    
        // If there are errors, update state and prevent submission
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
    
        try {
            let formData = { email, otp, password, password_confirmation: passwordConfirmation };
            const response = await loginUser(formData).unwrap();
            console.log("response", response);
            navigate("/login");
        } catch (err) {
            setApiError(err?.data?.error || "Invalid login credentials.");
            setErrors((prev) => ({
                ...prev,
                apiError: err?.data?.error || "Invalid login credentials.",
            }));
        }
    };
    

    return (
        <div className="login-container">
            <div className="login-box">
                <h2 className="text-center mb-4">Reset Password</h2>
                <form onSubmit={handleSubmit}>
                    {/* Password Field */}
                    <div className="mb-3 text-start position-relative">
                        <label htmlFor="password" className="form-label">Password</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                id="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    validateFields("password", e.target.value);
                                }}
                            />
                            <FontAwesomeIcon
                                className="password-show-hide"
                                icon={showPassword ? faEyeSlash : faEye}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    </div>

                    {/* Confirm Password Field */}
                    <div className="mb-3 text-start position-relative">
                        <label htmlFor="passwordConfirmation" className="form-label">Confirm Password</label>
                        <div className="input-group">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className={`form-control ${errors.passwordConfirmation ? "is-invalid" : ""}`}
                                id="passwordConfirmation"
                                placeholder="Confirm your password"
                                value={passwordConfirmation}
                                onChange={(e) => {
                                    setPasswordConfirmation(e.target.value);
                                    validateFields("passwordConfirmation", e.target.value);
                                }}
                            />
                            <FontAwesomeIcon
                                className="password-show-hide"
                                icon={showConfirmPassword ? faEyeSlash : faEye}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            />
                        </div>
                        {errors.passwordConfirmation && <div className="invalid-feedback">{errors.passwordConfirmation}</div>}
                    </div>

                    <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                    {APIerror && <div className="login-api-error text-danger mt-2">{APIerror}</div>}
                </form>
            </div>
        </div>
    );
};

export default Login;
